import BundleSections from "../../shared/data/jsons/bundleSections.json";
import BundleActivities from "../../shared/data/jsons/local_db_activities.json";
import BundleDocs from "../../shared/data/jsons/local_db_docs.json";
import BundleSuperPowers from "../../shared/data/jsons/local_db_super_powers.json";
import BundleActivitiesByCategory from "../../shared/data/jsons/local_db_activities_by_cat.json";
import BundleActivitiesByTag from "../../shared/data/jsons/local_db_activities_by_tag.json";
import BundleCategories from "../../shared/data/jsons/local_db_categories.json";
import BundleActivitiesByTagAndCategory from "../../shared/data/jsons/bundleActivitiesByTagAndCategory.json";
import BundleActivitiesBySections from "../../shared/data/jsons/local_db_activities_by_sections.json";
import BundleQuotes from "../../shared/data/jsons/bundleQuotes.json";
import BundleIntegrationSteps from "../../shared/data/jsons/local_db_launch_steps.json";
import BunldeNews from "../../shared/data/jsons/local_db_news.json";
import BundleGameLabels from "../../shared/data/jsons/local_db_game_labels.json";
import BundleGameImages from "../../shared/data/jsons/local_db_game_images.json";
import BundleDocuments from "../../shared/data/jsons/local_db_docs.json";
import BundleMenuSettings from "../../shared/data/jsons/local_db_menu_settings.json";
import BunldeGameLabel from "../../shared/data/jsons/local_db_game_labels.json";
import BundleGameImage from "../../shared/data/jsons/local_db_game_images.json";
import BundleNews from "../../shared/data/jsons/local_db_news.json";
import BundleTips from "../../shared/data/jsons/local_db_tips.json";
import { LaunchStep, News } from "../../shared/models/Models";
import Tips from "../../shared/models/Tips";
import Docs from "../../shared/models/Docs";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getDBDocs } from "../../shared/services/Firebase/Database";
import { Platform } from "react-native";
import { AppTarget, getAppTarget, getHost } from "./Navigation/Host";

export const buildLocalDB = async (activities: any) => {

}

export const setLocalStorage = (data: { key: string, value: string }) => {
    const { key, value } = data;
    window.localStorage.setItem(key, value);
}

export const getLocalStorage = (data: { key: string }) => {
    const { key } = data;
    const value = window.localStorage.getItem(key);
    return value;
}

export const wipeLocalStorage = async () => {
    return window.localStorage.clear();
}

export const removeItemFromLocalStorage = (data: { key: string }) => {
    const { key } = data;
    return window.localStorage.removeItem(key);
}

export const getLocalActivities = async () => {
    return BundleActivities;
}

export const getLocalSuperPowers = async () => {
    return BundleSuperPowers;
}

// TIPS
export const getLocalTips = async () => {
    const tips: Tips = Tips.getInstance();
    const bundleTips = BundleTips;
    tips.sections = bundleTips.data.sections;
    tips.superpowers = bundleTips.data.superpowers;
    return BundleTips;
}


export const getLocalActivitiesByCategories = async () => {
    return BundleActivitiesByCategory;
}

export const getLocalActivitiesBySections = async () => {
    return BundleActivitiesBySections;
}

export const getLocalActivitiesByTagsAndCategories = async () => {
    return BundleActivitiesByTagAndCategory;
}

export const getLocalActivitiesByTags = async () => {
    return BundleActivitiesByTag;
}

export const getLocalCategories = async () => {
    return BundleCategories;
}

export const getLocalintegrationSteps = async () => {
    return BundleIntegrationSteps;
}

export const getLocalNews = async () => {
    const sessionsNews = await getNews();
    if (sessionsNews.ts > 0) {
        return sessionsNews;
    } else {
        const localNews = await recordLocalNews(BunldeNews);
        return localNews;
    }
}

export const getLocalDocs = async () => {
    // De bases tous nos documents sont dans BundleDocuments
    const docsInstance: Docs = Docs.getInstance();
    let docsToReturn = BundleDocuments.data;
    let referenceTs: number = BundleDocuments.ts;
    const appTarget: AppTarget = getAppTarget();
    if (appTarget === "public") {
        // A revoir quand on aura trouver un moyen sur de stocker les données en local
        // Afin d'avoir toujours les docs à jour, on va enregistrer en session les docs
        // On récupères les documents en session
        if (docsInstance.ts > BundleDocuments.ts) {
            // Les documents en session ont été mis à jour après les documents du bundle, donc on va récupérer sur Firebases les documents mis à jour depuis le TS de la session
            referenceTs = docsInstance.ts;
        }
        // On ne va récupérer les docs sur Firebase, que si le dernier ts est à plus de 12h
        const currentTime = new Date().getTime();
        let sessionData = docsInstance.data;
        docsInstance.ts = currentTime;
        if (currentTime - referenceTs > 12 * 60 * 60 * 1000) {
            let updatedDocsArray = await getDBDocs({ ts: referenceTs });
            console.log({ updatedDocsArray });
            // Tout document qui revient est plus récent que ce qui est en session et dans le bundle
            for (const anUpdatedDocIndex in updatedDocsArray) {
                if (Object.prototype.hasOwnProperty.call(updatedDocsArray, anUpdatedDocIndex)) {
                    const anUpdatedDoc = updatedDocsArray[anUpdatedDocIndex];
                    sessionData[anUpdatedDoc.key] = anUpdatedDoc.data;
                }
            }
        }
        // On va maintenant remplacer les documents mises à jour dans le bundle
        for (const aSessionDocKey in sessionData) {
            if (Object.prototype.hasOwnProperty.call(sessionData, aSessionDocKey)) {
                const aSessionDoc = sessionData[aSessionDocKey];
                docsToReturn[aSessionDocKey] = aSessionDoc;
            }
        }
        // On va d'abord enregistrer en session ces nouveaux documents
        docsInstance.data = docsToReturn;
        //console.log(JSON.stringify({ data: docsToReturn, ts: currentTime }))
        return { data: docsToReturn, ts: currentTime };
    }

    return { data: docsToReturn, ts: referenceTs };
}

export const recordLocalDocInSession = async (docsToRecord: { ts: number, data: { [key: string]: any } }) => {
    try {
        console.log("SESSION", docsToRecord);
        await AsyncStorage.setItem("docs", JSON.stringify(docsToRecord));
        console.log("DOC RECORDED");
        return docsToRecord;
    } catch (error) {
        console.log(error);
    }
}

export const recordLocalNews = async (newsToRecord: { ts: number, data: { [key: string]: News } }) => {
    await sessionStorage.setItem("news", JSON.stringify(newsToRecord));
    return newsToRecord;
}

export const recordLocalLaunchSteps = async (launchStepsToRecord: { ts: number, data: { [key: string]: LaunchStep } }) => {
    // A voir si on enregistre en session
}

// ********** GET SESSIONS ACTIVITIES **********
export const getSessionsActivities = async () => {
    const sessionActivities = sessionStorage.getItem("activities");
    if (sessionActivities !== null) {
        return JSON.parse(sessionActivities);
    }
    return { data: {}, ts: new Date().getTime() };
}

export const recordSessionsActivities = async (data: any) => {
    try {
        await sessionStorage.setItem("activities", JSON.stringify({ data, ts: new Date().getTime() }));
    } catch (error) {
    }
}

// ********** GET SESSIONS CATEGORIES **********
export const getSessionsCategories = async () => {
    const sessionCategories = sessionStorage.getItem("categories");
    if (sessionCategories !== null) {
        return JSON.parse(sessionCategories);
    }
    return { data: {}, ts: new Date().getTime() };
}

export const recordSessionsCategories = async (data: any) => {
    try {
        await sessionStorage.setItem("categories", JSON.stringify({ data, ts: new Date().getTime() }));
    } catch (error) {
    }
}

// ********** GET SESSIONS NEWS **********
export const getSessionsNews = async () => {
    const sessionNews = sessionStorage.getItem("news");
    if (sessionNews !== null) {
        return JSON.parse(sessionNews)
    }
    return { data: {}, ts: new Date().getTime() }
}

export const recordSessionsNews = async (data: any) => {
    try {
        await sessionStorage.setItem("news", JSON.stringify({ data, ts: new Date().getTime() }))
    } catch (error) {

    }
}


export const getSessionsPremiumCards = async () => {
    const sessionPremiumCards = sessionStorage.getItem("premiumCards");
    if (sessionPremiumCards !== null) {
        return JSON.parse(sessionPremiumCards);
    }
    return { data: {}, ts: new Date().getTime() };
}


export const recordSessionsPremiumCards = async (data: any) => {
    try {
        await sessionStorage.setItem("premiumCards", JSON.stringify({ data, ts: new Date().getTime() }));
    } catch (error) {
    }
}

export const getLocalQuotes = async () => {
    return BundleQuotes;
}

export const recordLocalActivities = async (activitiesToRecord: any) => {
    return true;
}

export const getDownloadedActivities = async () => {
    return [];
}

// NEWS
export const getNews = async () => {
    const sessionsNews = sessionStorage.getItem("news");
    if (sessionsNews !== null) {
        return JSON.parse(sessionsNews);
    }
    return { data: {}, ts: 0 };
}

export const recordNews = async (data: any) => {
    try {
        await sessionStorage.setItem("news", JSON.stringify({ data, ts: new Date().getTime() }));
    } catch (error) {
    }
}

export const getLocalGameLabels = async () => {
    return BundleGameLabels;
}

export const getLocalGameImages = async () => {
    return BundleGameImages;
}

// NEWS
export const getSessionDocs = async () => {
    const sessionsDocs = await AsyncStorage.getItem("docs");
    console.log("DOC RECORDED");
    if (sessionsDocs !== null) {
        return JSON.parse(sessionsDocs);
    }
    return { data: {}, ts: 0 };
}
